import CashClosureFooter from './CashClosureFooter';

interface CashClosureSummaryProps {

  closureNumber?: string;

  expectedCash: number;
  countedCash: number;
  difference: number;

}

const CashClosureSummary: React.FC<CashClosureSummaryProps> = ({

  closureNumber,
  expectedCash,
  countedCash,
  difference,

}) => {

  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      
      {/* HEADER */}
      <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">

        <h3 className="font-medium text-black dark:text-white">
          Resultado del Cierre
        </h3>

        {closureNumber && (
          <p className="mt-1 font-mono text-xs text-gray-500">
            {closureNumber}
          </p>
        )}

      </div>

      {/* FOOTER RESULT */}
      <CashClosureFooter
        expectedCash={expectedCash}
        countedCash={countedCash}
        difference={difference}
      />

    </div>

  );

};

export default CashClosureSummary;